import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Alert, Paper } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import ImagePicker from '../../components/imagepicker/ImagePicker';
import { getHero, saveHero } from '../../api';
import { toImgSrcKey } from '../../utils/cdn';
import { blackIconTheme } from '../../theme/blackIconTheme';

/**
 * Hero editor
 * керує hero-картинкою для сторінки home
 */
export default function HeroEditor() {

    const [value, setValue] = useState([]);   // imageKey[]
    const [initial, setInitial] = useState([]);
    const [busy, setBusy] = useState(false);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');
    const [saved, setSaved] = useState(false);

    /* ================= LOAD HERO ================= */

    useEffect(() => {
        loadHero();
    }, []);

    async function loadHero() {
        setLoading(true);
        setErr('');
        setSaved(false);

        try {
            const data = await getHero('home');

            if (data?.imageKey) {
                setValue([data.imageKey]);
                setInitial([data.imageKey]);
            } else {
                setValue([]);
                setInitial([]);
            }

        } catch (e) {
            console.error(e);
            setErr('Не вдалося завантажити hero');
        } finally {
            setLoading(false);
        }
    }

    /* ================= SAVE HERO ================= */

    async function handleSave() {
        if (!value.length) return;

        setBusy(true);
        setErr('');
        setSaved(false);

        try {
            await saveHero('home', value[0]);

            setInitial(value);
            setSaved(true);

        } catch (e) {
            console.error(e);
            setErr(e?.message || 'Помилка збереження hero');
        } finally {
            setBusy(false);
        }
    }

    /* ================= STATES ================= */

    const changed =
        JSON.stringify(initial) !== JSON.stringify(value);

    const previewSrc =
        value?.[0] ? toImgSrcKey(value[0]) : '';

    /* ================= RENDER ================= */

    return (
        <ThemeProvider theme={blackIconTheme}>
            <Box>

                <Typography variant="h5" sx={{ mb: 2 }}>
                    Hero зображення (Home)
                </Typography>

                {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
                {saved && <Alert severity="success" sx={{ mb: 2 }}>Збережено</Alert>}

                <Paper sx={{ p: 3 }}>

                    {/* PREVIEW */}
                    {!!previewSrc && (
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Поточне зображення
                            </Typography>

                            <img
                                src={previewSrc}
                                alt="Hero"
                                style={{
                                    width: '100%',
                                    maxHeight: 380,
                                    objectFit: 'cover',
                                    borderRadius: 8,
                                }}
                            />
                        </Box>
                    )}

                    {/* IMAGE PICKER */}
                    <ImagePicker
                        value={value}
                        onChange={setValue}
                        single
                        folder="hero"
                        libraryPrefix="hero"
                        thumbHeight={220}
                    />

                    {/* ACTIONS */}
                    <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                        <Button
                            variant="contained"
                            disabled={!changed || busy || loading}
                            onClick={handleSave}
                        >
                            Зберегти
                        </Button>

                        <Button
                            variant="outlined"
                            disabled={busy || loading}
                            onClick={loadHero}
                        >
                            Скасувати
                        </Button>
                    </Box>

                </Paper>
            </Box>
        </ThemeProvider>
    );
}